export default function TaxiCard({
  name,
  price,
  type,
  image,
  priceLabel = "Starting",
}) {
  const handleWhatsApp = () => {
    const message = `Hi VK Bike On Rent,

I want to enquire about the following taxi service:

Vehicle/Service: ${name}
Type: ${type}
Price: ${price}

Location: Udaipur

Please share current availability, inclusions and trip details.`;

    const whatsappUrl = `https://wa.me/919983765215?text=${encodeURIComponent(
      message
    )}`;

    window.open(
      whatsappUrl,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <article className="taxi-card">

      {/* =====================================================
          TAXI IMAGE
      ====================================================== */}

      <div className="taxi-image-wrapper">
        <img
          src={image}
          alt={`${name} taxi service in Udaipur`}
          className="taxi-image"
          width="400"
          height="220"
          loading="lazy"
          decoding="async"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src =
              "/taxi-placeholder.jpg";
          }}
        />
      </div>

      {/* =====================================================
          TAXI CONTENT
      ====================================================== */}

      <div className="taxi-content">

        <h3 className="taxi-title">
          {name}
        </h3>

        <p className="taxi-type">
          {type}
        </p>

        <p className="taxi-price">
          <span className="price-label">
            {priceLabel}{" "}
          </span>

          <strong>
            {price}
          </strong>
        </p>

        {/* =================================================
            WHATSAPP CTA
        ================================================== */}

        <button
          type="button"
          className="taxi-btn"
          onClick={handleWhatsApp}
          aria-label={`Check availability for ${name} taxi service in Udaipur on WhatsApp`}
        >
          📲 Check Availability on WhatsApp
        </button>

      </div>

    </article>
  );
}